import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { findImprIdpDirectories } from '../../api/commonServices';
import { Endpoints } from '../../api/constants';
import { deleteImprIdpUser, findImprIdpUsers } from '../../api/portalServices';

export const useIdentityDir = () => {
  return useQuery({
    queryKey: ['identityDirectories'],
    queryFn: async () => {
      const response = await findImprIdpDirectories(Endpoints.IMPR_IDP_DIR_FIND);
      return response.directories;
    },
    retry: false,
    refetchOnWindowFocus: false,
  });
};

// Delete identity user
export const useDeleteIdentityUser = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteImprIdpUser,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['identityUsers'] });
    },
  });
};
